import { styles } from '@app/services/app-styles.service';

const tag = {
    root: {
        borderRadius: styles().borderRadiusItem,
        gap: '0.25rem',
    },
};

export default tag;
